import { Alert, Box, Card, CardContent, Chip, Typography } from '@mui/material';
import { ArrowForward } from '@mui/icons-material';
import React from 'react';
import { CutterHistory } from '../../types/cutterHistory';

export interface CutterDetailsHistorySubscriptionsProps {
    cutter: CutterHistory;
}

export const CutterDetailsHistorySubscriptions: React.FC<CutterDetailsHistorySubscriptionsProps> = ({ cutter }) => {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            {cutter.contract.filter(subscr => subscr.contract).length > 0 ? (
                <Box>
                    <Typography variant="subtitle2" component="div" sx={{ color: 'secondary.main', mb: 2 }}>
                        Subscription History ({cutter.contract.filter(subscr => subscr.contract).length})
                    </Typography>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                        {cutter.contract.filter(subscr => subscr.contract).map((contract, index) => (
                            <Card 
                                key={index} 
                                variant="outlined"
                                sx={{ 
                                    backgroundColor: contract.isactive 
                                        ? (theme) => theme.palette.mode === 'light' ? 'success.light' : 'success.dark'
                                        : 'background.paper'
                                }}
                            >
                                <CardContent sx={{ py: 1, '&:last-child': { pb: 1 } }}>
                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 2 }}>
                                        <Typography variant="subtitle2" fontWeight="bold" component="span" sx={{ width: '30%', flexShrink: 0 }}>
                                            {contract.contract}
                                        </Typography>
                                        <Typography variant="body2" sx={{ color: 'text.primary', fontWeight: 500, flexGrow: 1, display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                            {new Date(contract.fromDate).toLocaleDateString()} 
                                            <ArrowForward sx={{ fontSize: '1rem' }} /> 
                                            {contract.todate ? new Date(contract.todate).toLocaleDateString() : 'Ongoing'}
                                        </Typography>
                                        {contract.isactive && (
                                            <Chip 
                                                label="Active" 
                                                color="success" 
                                                size="small"
                                                sx={{ fontWeight: 'bold', flexShrink: 0 }}
                                            />
                                        )}
                                    </Box>
                                </CardContent>
                            </Card>
                        ))}
                    </Box>
                </Box>
            ) : (
                <Alert severity="info">No contract history available</Alert>
            )}
        </Box>
    );
};

export default CutterDetailsHistorySubscriptions;
